export const Icon = ({ as: Component, className, size = 18, strokeWidth = 1.8, ...props }) => (
  <Component
    aria-hidden="true"
    className={className}
    focusable="false"
    size={size}
    strokeWidth={strokeWidth}
    {...props}
  />
)
